import React, { useMemo } from 'react';
import List from '../../../components/list/List';
import text, { formatSqmArea } from '../../../text';
import classNames from 'classnames';
import { _2dMapQuoteTypes } from '@larki/shared/type/order.v2';
import { usePaymentContext } from '../../hooks/usePaymentContext';

const getDescription = (displayName: string, area?: number): string =>
  area
    ? text('productData', {
        product: displayName,
        area: formatSqmArea(area),
      })
    : displayName;

const ChargeItem = ({
  charge,
  isApproximate = false,
  areaIsAlignedMiddle = false,
  hideArea = false,
}: {
  charge: _2dMapQuoteTypes['charge'];
  isApproximate?: boolean;
  areaIsAlignedMiddle?: boolean;
  hideArea?: boolean;
}) => {
  const { formatPrice } = usePaymentContext();

  const displayName = useMemo(
    () => text(`${charge.product}3D`),
    [charge.product]
  );

  return (
    <>
      {/* @ts-expect-error midText */}
      <List.Item
        className={classNames('charge', {
          isApproximate: isApproximate,
        })}
        description={
          hideArea || areaIsAlignedMiddle
            ? displayName
            : getDescription(displayName, charge.quantity)
        }
        value={
          charge.subtotal === 'TBC'
            ? text('toBeConfirmed')
            : formatPrice(charge.subtotal)
        }
        {...(areaIsAlignedMiddle && {
          midText: `Area: ${formatSqmArea(charge.quantity)}`,
        })}
      />

      {charge.appliedFees?.map((fee, i) => (
        <List.Item
          key={i}
          description={fee.metadata.displayName}
          value={formatPrice(fee.amount)}
          // @ts-expect-error midText
          midText={areaIsAlignedMiddle ? <span /> : null}
          // add span to align tr > td if there's a middle text
        />
      ))}

      {charge.appliedDiscounts.map((discount, i) => (
        <List.Item
          key={i}
          description={
            <>
              <span className='font-grey--3 text-strikethrough mr-1'>
                Full price: {formatPrice(discount.metadata.baseAmount || 0)},
              </span>
              <span className='mr-1 font-grey--3'>
                save {formatPrice(discount.amount)} +GST
              </span>
            </>
          }
          value=''
          className='pl-3 font-12'
          // @ts-expect-error midText
          midText={areaIsAlignedMiddle ? <span /> : null}
          // add span to align tr > td if there's a middle text
        />
      ))}
    </>
  );
};

export default ChargeItem;
